import daska1 from "./images/daska1.jpg";
import daska2 from "./images/daska2.jpg";
import daska3 from "./images/daska3.jpg";
import daska4 from "./images/daska4.png";
import daska5 from "./images/daska5.png";
import daska6 from "./images/daska6.png";
import daska7 from "./images/daska7.png";
import daska8 from "./images/daska8.png";
import daska9 from "./images/daska9.jpg";
import daska10 from "./images/daska10.jpg";
import daska11 from "./images/daska11.png";
import daska12 from "./images/daska12.jpg";
import daska13 from "./images/daska13.jpg";
import daska14 from "./images/daska14.jpg";
import ukras1 from "./images/ukras1.jpg";
import ukras2 from "./images/ukras2.png";
import ukras3 from "./images/ukras3.jpg";
import ukras4 from "./images/ukras4.jpg";
import ukras5 from "./images/ukras5.png";
import ukras6 from "./images/ukras6.jpg";
import ukras7 from "./images/ukras7.png";
import ukras8 from "./images/ukras8.png";
import ukras9 from "./images/ukras9.jpg";
import ukras10 from "./images/ukras10.jpg";
import ukras11 from "./images/ukras11.jpg";
import ostalo1 from "./images/ostalo1.jpg";
import ostalo2 from "./images/ostalo2.jpg";
import ostalo3 from "./images/ostalo3.jpg";
import ostalo4 from "./images/ostalo4.jpg";
import ostalo5 from "./images/ostalo5.png";
import ostalo6 from "./images/ostalo6.jpg";
import ostalo7 from "./images/ostalo7.jpg";
import ostalo8 from "./images/ostalo8.jpg";
import ostalo9 from "./images/ostalo9.jpg";
import ostalo10 from "./images/ostalo10.png";
import ostalo11 from "./images/ostalo11.png";
import ostalo12 from "./images/ostalo12.png";
import ostalo13 from "./images/ostalo13.png";
export const daske = [
    {
      src: daska1,
      width: 3,
      height: 3,
      className: "rounded-4",
      alt: "Oći smiju ti se dok me gledaš"
    },
    {
        src: daska10,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Daska za fešte"
    },
    {
        src: daska9,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Daska lovac"
    },
    {
        src: daska3,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Pojest, popit, zagalamit"
    },
    {
        src: daska13,
        width: 4,
        height: 3,
        className: "rounded-4",
        alt: "Vino sirevi i kumovi"
    }
  ];

  export const ukrasi = [
    {
      src: ukras10,
      width: 4,
      height: 3,
      className: "rounded-4",
      alt: "Viseći ukras za dijete"
    },
    {
        src: ukras1,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Trodijelna slika"
    },
    {
        src: ukras3,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Gravirana slika za zid"
    },
    {
        src: ukras8,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Ukras za klet"
    },
    
  ];
  export const ostalo = [
    {
        src: ostalo1,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Podmetači za čaše"
    },
    {
        src: ostalo2,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Ukras za vjenčanje"
      },
      {
        src: ostalo3,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Otvarač za pivo"
      },
    
    {
        src: ostalo4,
        width: 3,
        height: 3,
        className: "rounded-4",
        alt: "Natpis za ulazna vrata"
      }
      
  ]
  export const galerija = [
    ...daske, ...ukrasi, ...ostalo,
    {
      src: daska4,
      width: 4,
      height: 3,
      className: "rounded-4",
      alt: "Enjoy life"
  },
  {
    src: daska2,
    width: 3,
    height: 4,
    className: "rounded-4",
    alt: "Daska Wine, cheese and friends"
  },
  {
    src: ukras2,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Pikado"
  },
  {
    src: ostalo5,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Cjenik"
  },
  {
    src: daska8,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Daska Jedi, Moli, Voli"
  },
  {
    src: ukras4,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Slika automobila"
  },
  {
    src: ostalo7,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Poklon kutija"
  },
  {
    src: daska7,
    width: 4,
    height: 3,
    className: "rounded-4",
    alt: "Daska za masti i proteine"
  },
  {
    src: ukras7,
    width: 3,
    height: 4,
    className: "rounded-4",
    alt: "Viseća daska motor"
  },
  {
    src: ostalo6,
    width: 3,
    height: 4,
    className: "rounded-4",
    alt: "Drvene kuhače"
  },
  {
    src: daska12,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Daska Lovac"
  },
  {
    src: ukras11,
    width: 3,
    height: 4,
    className: "rounded-4",
    alt: "Viseći ukras za dijete"
  },
  {
    src: ostalo8,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Stalak za knjigu"
  },
  {
    src: daska11,
    width: 3,
    height: 4,
    className: "rounded-4",
    alt: "Daska Dinamo za klet"
  },
  {
    src: daska14,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Wine, cheese and friends"
  },
  {
    src: ostalo9,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Hranilica za pse"
  },
  {
    src: ukras9,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Gravirana karta na daski"
  },
  {
    src: ostalo10,
    width: 3,
    height: 4,
    className: "rounded-4",
    alt: "Drvena poklon vrećica za butelju vina"
  },
  {
    src: ukras5,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Hranilica za pse"
  },
  {
    src: ostalo11,
    width: 3,
    height: 4,
    className: "rounded-4",
    alt: "Kućni broj"
  },
  {
    src: ostalo12,
    width: 4,
    height: 3,
    className: "rounded-4",
    alt: "Drveni sanduk za pivo"
  },
  {
    src: ostalo13,
    width: 4,
    height: 3,
    className: "rounded-4",
    alt: "Drveni sanduk za pivo"
  },
  {
    src: ukras6,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Ukras za vrata"
  },
  {
    src: daska5,
    width: 3,
    height: 4,
    className: "rounded-4",
    alt: "Daska za lovce"
  },
  {
    src: daska6,
    width: 3,
    height: 3,
    className: "rounded-4",
    alt: "Kuća za odmor"
  },
  ]